import React from "react";
import { FaMapMarkerAlt, FaGlobeAfrica } from "react-icons/fa";

const LearningCard = ({
  title,
  description,
  footer,
  image,
  backColor,
  type,
}) => {
  const baseClasses =
    "relative h-[300px] md:h-[460px] lg:h-[400px] rounded-[24px] overflow-hidden group";
  const backgroundClass = image ? "" : backColor || "bg-slate-800";

  return (
    <div className={`${baseClasses} ${backgroundClass}`}>
      {image && (
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-[#041528] via-[#041528]/70 to-transparent" />

      <div className="absolute bottom-0 left-0 p-6 sm:p-8 text-white">
        <h3 className="text-2xl font-bold mb-3 sm:text-[32px]">{title}</h3>

        <p className="text-sm text-gray-200 leading-relaxed max-w-full mb-5 sm:text-base">
          {description}
        </p>

        <div className="flex items-center gap-2 text-[#E17A01] font-medium text-sm">
          <span>{footer}</span>

          {type === "onsite" ? <FaMapMarkerAlt /> : <FaGlobeAfrica />}
        </div>
      </div>
    </div>
  );
};

export default LearningCard;
